﻿import { action, computed, makeObservable, observable } from 'mobx';
import { DropdownOption, PartnerType } from '../models';

const OTHER_PARTNER_TYPE_CODE = 'other';

export class PartnerTypeStore {
  @observable partnerTypeOptions: DropdownOption<PartnerType>[] = [];

  constructor() {
    makeObservable(this);
  }

  @action
  setPartnerTypeOptions(options: DropdownOption<PartnerType>[]): void {
    this.partnerTypeOptions = options;
  }

  @computed
  get otherPartnerTypeId(): number | undefined {
    return this.partnerTypeOptions.find((option) => option.value.typeCode === OTHER_PARTNER_TYPE_CODE)?.value.partnerTypeId;
  }

  isOtherPartnerType(partnerTypeId: number): boolean {
    return this.otherPartnerTypeId !== undefined && this.otherPartnerTypeId === partnerTypeId;
  }

  getPartnerTypeDisplayName(partnerTypeId: number): string {
    return this.partnerTypeOptions.find((option) => option.value.partnerTypeId === partnerTypeId)?.value.displayName ?? '';
  }
}
